import { render } from "./LiveEventManager.vue?vue&type=template&id=272e96a2&scoped=true"
import script from "./LiveEventManager.vue?vue&type=script&lang=js"
export * from "./LiveEventManager.vue?vue&type=script&lang=js"

import "./LiveEventManager.vue?vue&type=style&index=0&id=272e96a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-272e96a2"]])

export default __exports__